export enum HTTP_DATA {
  GET_COST_AND_EMISSIONS_PER_PORT = "/v1/port-cost-emission-report",
  GET_TOTAL_MONTHLY_COST_AND_EMISSIONS = "/v1/cost-emission-trend",

  GET_FDA_COST_AND_EMISSIONS_PER_PORT = "/v1/fda-port-cost-emission-report",
  GET_FDA_TOTAL_MONTHLY_COST_AND_EMISSIONS = "/v1/fda-cost-emission-trend",
  GET_FDA_STATISTICS = "/v1/fda-general-statistics",
}
